import React from 'react';
import useCursorGlow from '../hooks/useCursorGlow';

const CursorGlow = () => {
  const glowRef = useCursorGlow();

  return (
    <div
      ref={glowRef}
      style={{
        position: 'fixed',
        width: 320,
        height: 320,
        borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(232,130,26,0.12) 0%, transparent 70%)',
        pointerEvents: 'none',
        zIndex: 9997,
        transform: 'translate(-50%, -50%)',
        transition: 'opacity 0.3s',
        opacity: 0,
      }}
    />
  );
};

export default CursorGlow;
